<template>
  <SidePopup
    :title="titulo"
    overlayNotBack
    :loading="loading"
    @submit="onSubmit"
    @close="$emit('close')"
  >
    <FormField
      label="Descrição"
      v-model="form.descricao"
      personalizedMessage="A descrição é obrigatória"
      :validation="$v.form.descricao"
    />
    <FormField
      label="E-mail"
      v-model="form.email"
      personalizedMessage="Informe um e-mail válido"
      :validation="$v.form.email"
    />
    <FormSwitch v-model="form.ativo" label="Destinatário ativo" />

    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";
import FormButton from "@/components/form/FormButton";
import { required, email } from "vuelidate/lib/validators";
import {
  NOTIFICACAO_ADMIN_CRIAR_DESTINATARIO,
  NOTIFICACAO_ADMIN_ATUALIZAR_DESTINATARIO
} from "@/store/actions/notificacoesAdministrativas";

export default {
  name: "DestinatarioModalForm",
  components: {
    SidePopup,
    FormField,
    FormSwitch,
    FormButton
  },
  props: {
    idfornecedor: {
      type: String,
      required: true
    },
    destinatario: {
      type: Object,
      default: null
    }
  },
  validations: {
    form: {
      descricao: { required },
      email: { required, email }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        descricao: "",
        email: "",
        ativo: true
      }
    };
  },
  computed: {
    titulo() {
      return this.destinatario ? "Editar destinatário" : "Novo destinatário";
    }
  },
  created() {
    if (this.destinatario) {
      this.form = {
        descricao: this.destinatario.descricao || "",
        email: this.destinatario.email || "",
        ativo: this.destinatario.ativo !== false
      };
    }
  },
  methods: {
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      this.loading = true;
      const payload = {
        descricao: this.form.descricao.trim(),
        email: this.form.email.trim(),
        ativo: this.form.ativo
      };

      try {
        let salvo;
        if (this.destinatario && this.destinatario.id) {
          salvo = await this.$store.dispatch(
            NOTIFICACAO_ADMIN_ATUALIZAR_DESTINATARIO,
            {
              idfornecedor: this.idfornecedor,
              id: this.destinatario.id,
              data: payload
            }
          );
          this.$vueOnToast.pop(
            "success",
            "Destinatário atualizado com sucesso"
          );
        } else {
          salvo = await this.$store.dispatch(
            NOTIFICACAO_ADMIN_CRIAR_DESTINATARIO,
            {
              idfornecedor: this.idfornecedor,
              data: payload
            }
          );
          this.$vueOnToast.pop(
            "success",
            "Destinatário cadastrado com sucesso"
          );
        }
        this.$emit("saved", salvo);
      } catch (err) {
        // erro tratado na action
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
